<template>
<div>
  <!-- vertical 적용 전 -->
  <!-- <el-row class="title-wrapper">
      <div class="l-container">
        <div class="title-h3 mr-r15">트래픽 목록</div>
        <span v-show="showSummary" class="tit">스마트 추적</span>
        <div v-show="showSummary" class="list-info">
          <ul class="lists">
            <li v-for="(label, index) in smartTraceLabel.smartTraceList" :key="label"><span class="num">{{ index + 1 }}</span>{{ label }}</li>
          </ul>
        </div>
      </div>
      <div class="r-container">
        <div v-show="showSummary" class="list-info">
          <ul class="r-list">
            <li> 기간 <span class="high">{{ smartTraceLabel.period }}</span></li>
            <li> 단위 <span class="high">{{ smartTraceLabel.meter }}</span></li>
            <li> 방향 <span class="high">{{ smartTraceLabel.direction }}</span></li>
          </ul>
        </div>
      </div>
    <div class="btn-wrapper vertical-center-box">
      <el-button class="mr-l10 mr-r4" size="mini" :disabled="loadBtnDisabled" @click="loadData"> 조회 </el-button>
      <el-button class="mr-l15" size="mini" :disabled="!exportExcelFlag" @click="exportExcelTrafficData">
        <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
        <span style="left:2px;bottom:5px;">  엑셀출력</span>
      </el-button>
    </div>
  </el-row> -->

  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">트래픽 목록</div>
        <span v-show="showSummary" class="tit">스마트 추적</span>
        <div v-show="showSummary" class="list-info">
          <ul class="lists">
            <li v-for="(label, index) in smartTraceLabel.smartTraceList" :key="label"><span class="num">{{ index + 1 }}</span>{{ label }}</li>
          </ul>
        </div>
      </div>
      <div class="vertical-center-box">
        <div v-show="showSummary" class="list-info">
          <ul class="r-list">
            <li> 기간 <span class="high">{{ smartTraceLabel.period }}</span></li>
            <li> 단위 <span class="high">{{ smartTraceLabel.meter }}</span></li>
            <li> 방향 <span class="high">{{ smartTraceLabel.direction }}</span></li>
          </ul>
        </div>
        <el-button class="mr-l10 mr-r4" size="mini" :disabled="loadBtnDisabled" @click="loadData"> 조회 </el-button>
        <el-button class="mr-l15" size="mini" :disabled="!exportExcelFlag" @click="exportExcelTrafficData">
          <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
          <span style="left:2px;bottom:5px;">  엑셀출력</span>
        </el-button>
      </div>
    </el-row>
  </div>
  <el-row :style="tableHeightStyle">
    <el-table-wrapper v-loading="loading" ref="trafficTable" :column-default="columnDefault" :columns="tableColumns" :data="trafficData" :total="total" :show-custom-header="false" :pagination="true" remote @condition-change="loadData"></el-table-wrapper>
  </el-row>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { getDateToString } from '@/utils/date';
import msgUtil from '@/utils/message';
import FlowAPI from '@/api/performance/flow-analysis/flow-analysis';
import FileApi from '@/api/common/file';

export default {
  name: 'WTrafficListView',
  props: {
    flowParams: Object,
  },
  data() {
    return {
      columnDefault,
      loading: false,
      exportExcelFlag: false,
      tableColumns: [
        {
          prop: 'timestamp',
          label: '발생일시',
          width: 150,
          formatter: this.getDateFormatter,
        },
        {
          prop: 'deviceIp',
          label: '장비',
          formatter: this.formatterForDevice,
        },
        {
          prop: 'input',
          label: '인터페이스(In)',
          formatter: this.formatterForInput,
        },
        {
          prop: 'output',
          label: '인터페이스(Out)',
          formatter: this.formatterForOutput,
        },
        {
          prop: 'srcIpv4',
          label: 'IP(In)',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'dstIpv4',
          label: 'IP(Out)',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'srcPort',
          label: '포트(In)',
          width: 120,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'dstPort',
          label: '포트(Out)',
          width: 120,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'protocol',
          label: '프로토콜',
          width: 100,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'octets',
          label: 'Bytes',
          width: 100,
          formatter: this.convertValue,
        },
        {
          prop: 'packets',
          label: 'Packets',
          width: 100,
          formatter: this.convertValue,
        },
      ],
      showSummary: false,
      trafficData: [],
      total: 0,
    };
  },
  computed: {
    /**
     * 조회 버튼 활성화 여부 (스마트 추적 카드 미선택시 비활성화)
     * @author jeee12
     */
    loadBtnDisabled() {
      let enableLoad = false;
      if (this.flowParams) {
        enableLoad = !isEmpty(this.flowParams.smartTraceFilter);
      }
      return !enableLoad;
    },
    /**
     * 테이블 최소 높이 지정 (스마트 추적 요약 상단바 특정 스크롤 위치에서 표현하기위해)
     * @author jeee12
     */
    tableHeightStyle() {
      if (!this.loadBtnDisabled) {
        return {
          minHeight: '560px',
        };
      }
      return {};
    },
    /**
     * 스마트 추적 요약 상단바 표현 라벨 가공
     * @author jeee12
     */
    smartTraceLabel() {
      let smartTrace = {
        smartTraceList: [],
        period: '',
        meter: '',
      };
      if (this.showSummary) {
        const flowParams = this.flowParams;
        const dateFormat = 'YYYY-MM-DD HH:mm';
        const labelList = [];

        flowParams.summarySmartTraceList.forEach((info) => {
          let label = '';
          if (info.type.indexOf('src') > -1) {
            label += '[IN] ';
          } else if (info.type.indexOf('dst') > -1) {
            label += '[OUT] ';
          }
          label += info.name;
          labelList.push(label);
        });

        smartTrace = {
          smartTraceList: labelList,
          period: `${getDateToString(flowParams.requestParamVO.startDateTime, dateFormat)} ~ ${getDateToString(flowParams.requestParamVO.endDateTime, dateFormat)}`,
          // period: '2020-02-25 15:20 ~ 2020-02-25 16:20',
          meter: flowParams.requestParamVO.meter === 'octets' ? 'bytes' : flowParams.requestParamVO.meter,
          direction: this.flowParams.direction,
        };
      }
      return smartTrace;
    },
  },
  watch: {
    flowParams: {
      handler() {
        this.initTableData();
        if (!isEmpty(this.flowParams.smartTraceFilter)) {
          this.showSummary = true;
        } else {
          this.showSummary = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    /**
     * 트래픽 목록 데이터 조회
     * @author jeee12
     */
    loadData() {
      const pagination = this.$refs.trafficTable.getPagination();
      const params = Object.assign(this.flowParams.requestParamVO, {
        smartTraceFilter: this.flowParams.smartTraceFilter,
        pageSize: pagination.pageSize,
        pageIndex: pagination.currentPage,
      });

      this.loading = true;
      FlowAPI.getFlowTrafficList({
        requestParamVO: params,
      })
        .then((response) => {
          if (response.data.success) {
            this.trafficData = response.data.data;
            this.total = response.data.total;
            this.exportExcelFlag = true;
            // this.pagination.total = response.data.data.totalPage * this.pagination.pageSize;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '트래팩 정보', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '트래팩 정보', false));
          throw new Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 스마트 추적 재로드, 초기화시 트래픽 목록 테이블 초기화
     * @author jeee12
     * @return {[type]} [description]
     */
    initTableData() {
      this.exportExcelFlag = false;
      this.trafficData = [];
      this.total = 0;
    },
    // /**
    //  * 페이지 크기 change
    //  * @author jeee12
    //  * @param  {[type]} size [description]
    //  */
    // onPageSizeChange(size) {
    //   this.pagination.pageSize = size;
    //   this.loadData();
    // },
    // /**
    //  * 현재 페이지 change
    //  * @author jeee12
    //  * @param  {[type]} size [description]
    //  */
    // onPageCurrentChange(current) {
    //   this.pagination.currentPage = current;
    //   this.loadData();
    // },
    /**
     * 기간 날짜 형 변환
     * @author jeee12
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getDateFormatter(row, column, value) {
      return getDateToString(value);
    },
    /**
     * 테이블 값 (Bytes, Packet) 단위 변환
     * @author jeee12
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    convertValue(row, column, value) {
      if (column.property === 'octets') return `${convertValuByUnit(value, 'Byte', true, true, true)}B`;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/, ','); // packets 천단위 분리
    },
    /**
     * 테이블 데이터 빈 값 확인
     * @author jeee12
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * flow 분석 > 트래픽 목록의 엑셀 출력을 수행한다.
     * @author yelim
     */
    exportExcelTrafficData() {
      const pagination = this.$refs.trafficTable.getPagination();
      const start = Math.floor(this.total / 10000) * 10000;
      const params = Object.assign(this.flowParams.requestParamVO, {
        smartTraceFilter: this.flowParams.smartTraceFilter,
        // FIX 2019-03-21 Minyeong > 10000개 데이터 이상 엑셀로 출력하기 위한 매개변수 설정
        pageSize: start === 0 ? this.total : 10000,
        start: Math.floor(this.total / 10000) * 10000,
        pageIndex: pagination.currentPage,
      });
      FlowAPI.createFlowTrafficExcel({
        requestParamVO: params,
      })
        .then((response) => {
          if (response.data.success && response.data.data) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.OUTPUT, '엑셀', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.OUTPUT, '엑셀', false));
          throw new Error(e);
        });
    },
    /**
     * 장비 정보 formatter
     * @author Ju
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    formatterForDevice(row) {
      return isNil(row.deviceName) || row.deviceName === '' ? getValueAfterCheckEmpty(row.deviceIp) : row.deviceName;
    },
    /**
     * 인터페이스 (in) 정보 formatter
     * @author Ju
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    formatterForInput(row) {
      return isNil(row.inputName) || row.inputName === '' ? getValueAfterCheckEmpty(row.input) : row.inputName;
    },
    /**
     * 인터페이스 (out) 정보 formatter
     * @author Ju
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    formatterForOutput(row) {
      return isNil(row.outputName) || row.outputName === '' ? getValueAfterCheckEmpty(row.output) : row.outputName;
    },
  },
};
</script>

<style lang="scss" scoped>
$url: '../../../../../assets/img/';
.title-wrapper{
  margin-bottom: 10px;
  vertical-align: middle;
  display: inline-block;
  width: 100%;
}
.btn-wrapper {float: right}
.l-container {
  width: calc(100% - 565px);
  float: left
}
.r-container {
  // width: 412px;
  width: 420px;
  float: left
}
.list-info {
  display: inline-block;
  align-items: center;
  color: #565a5b;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  .title {
    font-size: 15px;
    padding-right: 15px;
    font-weight: 400;
    letter-spacing: -0.5px;
    float: left;
  }
  .lists {
    display: flex;
    float: left;
    // position: relative;
    top: 4px;
    margin-right: 3px;
    & > li {
      font-weight: 500;
      font-size: 12px;
      margin-right: 12px;
      vertical-align: middle;
    }
    & > li > .num {
      margin-top: 1px;
      display: inline-block;
      width: 19px;
      height: 19px;
      border-radius: 4px;
      background-color: #5e6170;
      color: #fff;
      font-size: 12px;
      line-height: 19px;
      text-align: center;
      margin-right: 4px;
    }
  }
  .r-list {
    display: flex;
    float: right;
    color: #343235;
    text-align: right;
    & > li {
      // margin-top: 7px;
      margin-left: 12px;
      padding-left: 8px;
      font-weight: 400;
      font-size: 12px;
      background: url($url+'dot_l.png') no-repeat 0 8px;
    }
    .high {
      color: #155ec7;
      font-weight: 500;
      margin-left: 2px;
    }
  }
}
@media only screen and (max-width: 1720px) {
  .title-wrapper{margin-bottom: 0}
  .l-container{width:90%}
  .r-container {
    width: calc(100% - 240px);
    margin-left: 88px;
    margin-top: 3px
  }
  .btn-wrapper {
    position: relative;
    top: -23px
  }
}




// $url: '../../../../../assets/img/';
//
// .list-info {
//   display: inline-block;
//   align-items: center;
//   // height: 50px;
//   // border: 1px solid #e9e9e9;
//   // background-color: #f1f1f1;
//   // padding: 15px 18px;
//   color: #565a5b;
//   box-sizing: border-box;
//   -moz-box-sizing: border-box;
//   -webkit-box-sizing: border-box;
//   // width: 100%;
//
//   .title {
//     font-size: 15px;
//     padding-right: 15px;
//     font-weight: 400;
//     letter-spacing: -0.5px;
//     float: left;
//   }
//   .lists {
//     display: flex;
//     float: left;
//     margin-right: 3px;
//
//     & > li {
//       font-weight: 500;
//       font-size: 12px;
//       margin-right: 20px;
//       vertical-align: middle;
//     }
//     & > li > .num {
//       margin-top: 1px;
//       display: inline-block;
//       width: 19px;
//       height: 19px;
//       border-radius: 4px;
//       background-color: #5e6170;
//       color: #fff;
//       font-size: 12px;
//       line-height: 19px;
//       text-align: center;
//       margin-right: 6px;
//     }
//   }
//   .r-list {
//     display: flex;
//     float: right;
//     color: #343235;
//     text-align: right;
//
//     & > li {
//       margin-left: 12px;
//       padding-left: 8px;
//       font-weight: 400;
//       font-size: 12px;
//       background: url($url+'dot_l.png') no-repeat 0 8px;
//     }
//
//     .high {
//       color: #155ec7;
//       // font-family:  'Open Sans', sans-serif;
//       font-weight: 500;
//       margin-left: 2px;
//     }
//   }
// }
// @media only screen and (max-width: 1800px) {
//   .list-info {
//     // height: 76px;
//     .lists {
//       float: none;
//     }
//     .r-list {
//       margin-top: 5px; //10px 190806
//       margin-left: -10px;
//       float: left;
//     }
//   }
// }
//
// @media only screen and (max-width: 1400px) {
//   .title-h3 {font-size: 16px;}
//   .mr-r15 {margin-right: 15px}
//   .tit {padding: 0 6px !important}
//   .list-info {
//     // height: 90px;
//     .lists {
//       & > li {
//         width: 180px;
//         line-height: 16px;
//       }
//     }
//     .r-list {
//       margin-top: 2px; //8px 190806
//       // margin-left: 67px;
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/views/performance/FlowAnalysis/components/view/TrafficListView.vue